import { Box, Button, Stack, Typography } from '@mui/material';
import PageLayout, {
  PageStack,
} from '@/common/components/PageLayout/PageLayout';
import { LelyButton } from '@/common/components';

const DIAGNOSTICS_APP_URL = 'https://astrocandiag-stage.farmsolutions-dev.ldf.lely.cloud/';
 // import.meta.env.VITE_DIAGNOSTICS_APP_URL ?? 'http://localhost:8080/';
const DIAGNOSTICS_IFRAME_URL = 'https://astrocandiag-stage.farmsolutions-dev.ldf.lely.cloud/';
 // import.meta.env.VITE_DIAGNOSTICS_IFRAME_URL ??
  //`/diagnostics-app/?install_origin=${encodeURIComponent(DIAGNOSTICS_APP_URL)}`;

function DiagnosticsPage() {
  const openStandaloneApp = () => {
    window.open(DIAGNOSTICS_APP_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <PageLayout testId="container-diagnostics">
      <PageStack>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          sx={{ flexShrink: 0 }}
        >
          <Typography variant="body2" color="text.secondary">
            Diagnostics runs here in Sense. Use &quot;Open / install app&quot;
            to install the standalone diagnostics PWA.
          </Typography>
          <LelyButton variant="secondary" onClick={openStandaloneApp}>
            Open / install app
          </LelyButton>
        </Stack>
        <Box
          sx={{
            width: '100%',
            height: '100%',
            minHeight: 0,
          }}
        >
          <iframe
            src={DIAGNOSTICS_IFRAME_URL}
            title="Diagnostics"
            style={{ width: '100%', height: '100%', border: 0 }}
          />
        </Box>
      </PageStack>
    </PageLayout>
  );
}

export default DiagnosticsPage;
